module.exports = __webpack_public_path__ + "static/media/icn_payment_frequency.8be074ff.svg";